import React, { useState, useEffect } from "react";

import "./DentalTechnology.css";
// import report from './Images/dentaltechnology/DSC_0328.jpg';
import { FaTooth, FaUsers, FaClock, FaDesktop } from "react-icons/fa"; // Import icons
import dental1 from "../home/Images/v1.png";
import dental2 from "../home/Images/IMG20240913134831.jpg";
import dental3 from "../home/Images/IMG_20231201_174221.jpg";
import dental4 from "../home/Images/dental2.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IoLocationOutline } from "react-icons/io5";
import { IoTimeOutline } from "react-icons/io5";
import {
  FaCoffee,
  FaChild,
  FaRegCheckCircle,
  FaTv,
  FaCalendarCheck,
  FaTag,
  FaCreditCard,
  FaMedkit,
} from "react-icons/fa";
function DentalTechnology() {
  const [showMore, setShowMore] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  // Check the screen size on mount and whenever the window is resized
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 480);
    };

    // Initialize screen size state
    handleResize();

    // Event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleReadMoreClick = () => {
    setShowMore(!showMore);
  };
  const barItems = [
    {
      icon: <FaTv size={40} />,
      label: "TVs + Headphone",
    },
    {
      icon: <FaCalendarCheck size={40} />,
      label: "Curated Experience",
    },
    {
      icon: <FaTag size={40} />,
      label: "Parking ",
    },
    {
      icon: <FaCreditCard size={40} />,
      label: "Flexible Bill Plans",
    },
    {
      icon: <FaCoffee size={40} />,
      label: "Beverage Bar",
    },
    {
      icon: <FaChild size={40} />,
      label: "Kids Corner",
    },
    { icon: <FaRegCheckCircle size={40} />, label: "OSHA Approved    " },
    { icon: <FaMedkit size={40} />, label: "Emergency Priority" },
    { icon: <FaClock size={40} />, label: " Time Management  " },
  ];

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    draggable: false,
    swipe: false,
    centerMode: true, // This will center the middle item
    focusOnSelect: true, // Automatically focus on the selected item
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="techno">
      <div className="techno-sec1">
        <div className="content">
          <div className="text-section">
            <p className="trusted-text">
              <mark className="domark">ABOUT BOMBAY DENTAL CLINIC</mark>
            </p>
            <h1 className="exceptional">
              <mark className="expmrk">Experience </mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk">Superior Dental </mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk">Care with Cutting </mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk">Edge Technology </mark>
            </h1>
            <a href="/booknow">
              <button className="book-button">BOOK ONLINE</button>
            </a>
            <p className="call-text">OR CALL <a href="tel:+918882672980">088826 72980</a></p>
          </div>
        </div>
      </div>
      <div className="home-sec6">
        <div className="insurance2"></div>
        <div className="transparent-pricing2">
          <h1 className="dental-care-heading">
            Elevate your dental experience with advanced technology
          </h1>
          <p className="dental-care-paragraph">
            At Bombay Dental Company, we are dedicated to providing exceptional
            dental care by harnessing the power of the latest technology.
          </p>

          <p className="dental-care-paragraph">
            {isSmallScreen && showMore && (
              <span>
                {" "}
                {/* Initially show only part of the content for small screens */}
                Our advanced tools and techniques, including digital X-rays,
                digital scanning impressions, and B-Class fully digitized
                autoclaves for 100% sterilization, are designed to elevate your
                dental experience. Our unwavering commitment to innovation
                allows us to offer the highest quality care. We ensure every
                visit is as comfortable and efficient as possible, prioritizing
                your needs.
              </span>
            )}
            {/* Always show the full text for large screens */}
            {!isSmallScreen && (
              <>
                Our advanced tools and techniques, including digital X-rays,
                digital scanning impressions, and B-Class fully digitized
                autoclaves for 100% sterilization, are designed to elevate your
                dental experience. Our unwavering commitment to innovation
                allows us to offer the highest quality care. We ensure every
                visit is as comfortable and efficient as possible, prioritizing
                your needs.
              </>
            )}
          </p>

          {isSmallScreen && (
            <button className="read-more-btn" onClick={handleReadMoreClick}>
              {showMore ? "Read Less" : "Read More"}
            </button>
          )}
        </div>
      </div>
      <div className="benefits-container">
        <div className="benefit">
          <FaTooth className="benefit-icon" />
          <h3 className="benefit-heading">Improved Accuracy</h3>
          <p className="benefit-description">
            Dental technology, such as digital X-rays & intraoral cameras,
            provides more accurate diagnoses & treatment
          </p>
        </div>
        <div className="benefit">
          <FaUsers className="benefit-icon" />
          <h3 className="benefit-heading">Increased Comfort</h3>
          <p className="benefit-description">
            Our advanced equipment can make dental procedures less painful &
            more comfortable.
          </p>
        </div>
        <div className="benefit">
          <FaClock className="benefit-icon" />
          <h3 className="benefit-heading">Faster Treatment </h3>
          <p className="benefit-description">
            With advanced dental technology, many procedures can be completed
            more quickly & efficiently.
          </p>
        </div>
        <div className="benefit">
          <FaDesktop className="benefit-icon" />
          <h3 className="benefit-heading">Better Patient Education</h3>
          <p className="benefit-description">
            Dental technology is used to educate about oral health & treatment.
            Like, 3D imaging help visualize teeth & gums.
          </p>
        </div>
      </div>
      <div
        className="dental-bar-menu"
        style={{ margin: " 0 0px", backgroundColor: "white" }}
      >
        <h2
          className="menu-title"
          style={{ textAlign: "center", color: " black" }}
        >
          Bombay Dental Company Menu
        </h2>
        <Slider {...sliderSettings}>
          {barItems.map((item, index) => (
            <div
              key={index}
              className="menu-item"
              style={{ textAlign: "center", height: "100%" }}
            >
              <div
                className="icon"
                style={{ marginBottom: "10px", color: " #0047AB" }}
              >
                {item.icon}
              </div>
              <p className="label" style={{ color: " #0047AB" }}>
                {item.label}
              </p>
            </div>
          ))}
        </Slider>
      </div>
      <div className="visit-us-container">
        <div className="images-container">
          <img src={dental1} alt="Waiting Area" className="image-item" />
          <img src={dental2} alt="Exam Room" className="image-item" />
          <img src={dental3} alt="Sign" className="image-item" />
          <img src={dental4} alt="Lounge" className="image-item" />
        </div>
        <div className="info-container">
          <h1 className="visit">Visit Us</h1>
          <p className="weare">
            We are conveniently located right on the Worli Naka, on the first
            floor of Atur House, opposite the Bharat Petroleum Pump. Our guards
            are very helpful, and free parking is provided easily upon asking.
          </p>
          <div className="lhflex">
            <div className="location">
              <h1 className="tp">
                <IoLocationOutline />
              </h1>
              <p>
                {" "}
                Bombay Dental Company
                <br />
                Atur House
                <br />
                First Floor, Flat no 2<br />
                Worli Naka, Worli
                <br />
                Mumbai 400018
              </p>
              <a
                href="https://maps.google.com/?q=5Bombay%20Dental%20Company%20Atur%20House%20Worli%20Naka%20Mumbai%20400018"
                className="directions-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Directions
              </a>
            </div>
            <div className="hours">
              <h1 className="tp">
                <IoTimeOutline />
              </h1>
              <p>
                {" "}
                Mon-Sat 9 am – 7 pm
                <br />
                Sun 10 am – 2 pm
                <br />
                Thursday off
              </p>
            </div>
          </div>
        </div>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps?q=5Bombay+Dental+Company+Atur+House+Worli+Naka+Mumbai+400018&output=embed"
            width="100%"
            height="450"
            style={{ border: "8px", borderRadius: "18px " }}
            allowFullScreen
            loading="lazy"
            title="Google Maps Location of Bombay Dental Company"
          />
        </div>
      </div>

      <div className="home-sec8">
        <div className="book-visit-container">
          <div className="online">
            <h1 className="book">Book your visit online</h1>
            <p className="view">
              Book your visit online and enjoy our unique No-wait policy, so
              that you have time for what you enjoy, and not spend your precious
              time in the doctor’s waiting area. A few lucky callers every month
              will be randomly shortlisted for a free scaling and polishing
              session.
            </p>
            <a href="/booknow">
              <button className="book-button1">BOOK ONLINE</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DentalTechnology;
